/* eslint-disable react/button-has-type */
/* eslint-disable react/require-default-props */
import React from 'react';
import ArrowIcon from 'assets/images/ambassador/arrow-right-small.svg';
import LockIcon from 'assets/images/ambassador/lock-small.svg';
import WhatsappIcon from 'assets/images/ambassador/whatsapp-small.svg';
import { Anchor, Button, PillSize, PillVariant, RouterLink } from './styles';

const ICONS = { arrow: ArrowIcon, whatsapp: WhatsappIcon, lock: LockIcon };

interface PillButtonProps {
  variant?: PillVariant;
  /** `lg` para a ação principal da página. */
  size?: PillSize;
  icon?: keyof typeof ICONS;
  /** Rota interna da plataforma. */
  to?: string;
  /** Link externo; abre em nova aba. */
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  children: React.ReactNode;
}

const PillButton: React.FC<PillButtonProps> = ({
  variant = 'green',
  size = 'md',
  icon = 'arrow',
  to,
  href,
  onClick,
  type = 'button',
  disabled = false,
  children,
}) => {
  const image = <img src={ICONS[icon]} alt="" />;
  // O cadeado vem antes do texto; as setas e o WhatsApp, depois.
  const content =
    icon === 'lock' ? (
      <>
        {image}
        {children}
      </>
    ) : (
      <>
        {children}
        {image}
      </>
    );

  if (to) {
    return (
      <RouterLink to={to} $variant={variant} $size={size} onClick={onClick}>
        {content}
      </RouterLink>
    );
  }

  if (href) {
    return (
      <Anchor
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        $variant={variant}
        $size={size}
        onClick={onClick}
      >
        {content}
      </Anchor>
    );
  }

  return (
    <Button type={type} $variant={variant} $size={size} onClick={onClick} disabled={disabled}>
      {content}
    </Button>
  );
};

export default PillButton;
